import * as React from "react";
import { Cookie, FileText, Scale, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
const legalLinks = [{
  title: "Impressum",
  url: "#",
  icon: Scale
}, {
  title: "Datenschutzerklärung",
  url: "#",
  icon: ShieldCheck
}, {
  title: "Allgemeine Geschäftsbedingungen (AGB)",
  url: "#",
  icon: FileText
}, {
  title: "Cookie-Richtlinien",
  url: "#",
  icon: Cookie
}];
export default function AdditionalLegalLinks() {
  const col1 = legalLinks.slice(0, 2);
  const col2 = legalLinks.slice(2, 4);
  return <section id="weitere-rechtliche-links" className="w-full bg-background pt-8 pb-16">
      
    </section>;
}